export const isReactiveQuery = (query) => {
    return !!query.ObservableExpression;
};
